import DataOps from './DataOps';
import { RegistrationRecord } from './RegistrationInterface';
import { v4 as uuidv4 } from 'uuid';

function buildRegistrationId(): string {
    return uuidv4();
}

export default class RegistrationOps {
    /** Create or upsert a confirmed registration document */
    static async createConfirmed(campId: string, sessionId: string, userId: string, childId: string, coachId?: string | null, hostId?: string | null): Promise<string> {
        const registrationId = buildRegistrationId();
        const now = new Date();
        const record: RegistrationRecord = {
            registrationId,
            campId,
            sessionId,
            coachId: coachId || null,
            hostId: hostId || null,
            userId,
            childId,
            createdAt: now,
            updatedAt: now,
            status: 'confirmed',
        };
        await DataOps.saveCustomDataToFirebase('registration', registrationId, record, true);
        return registrationId;
    }

    /** Mark an existing registration as cancelled */
    static async cancel(sessionId: string, userId: string, childId: string, cancelledBy: string): Promise<void> {
        // Look up latest active registration for this tuple and mark cancelled
        const reg = await DataOps.findLatestRegistration(sessionId, userId, childId);
        const registrationId = reg?.registrationId || uuidv4();
        const base: Partial<RegistrationRecord> = reg || {
            registrationId,
            campId: '',
            sessionId,
            userId,
            childId,
            createdAt: new Date(),
            updatedAt: new Date(),
            status: 'cancelled',
        } as any;
        const updated: RegistrationRecord = {
            ...(base as RegistrationRecord),
            status: 'cancelled',
            cancelledAt: new Date(),
            cancelledBy,
            updatedAt: new Date(),
        };
        await DataOps.saveCustomDataToFirebase('registration', registrationId, updated, true);
    }
}


